import { IndividualValidationStatus } from '../../../../consts/individualValidationStatus';
import { ValidationCheck } from '../../../../consts/validationCheck';

export const getIndividualValidationStatus = (validation: ValidationCheck, isValid: boolean) => {
  if (isValid) {
    return IndividualValidationStatus.Success;
  }

  // PhotoFromFuture stays off this list: a date later than today is an error rather than a warning.
  if ([ValidationCheck.BlurScore, ValidationCheck.DroneModelOk].includes(validation)) {
    return IndividualValidationStatus.Warning;
  }

  return IndividualValidationStatus.Error;
};
